import { MediaServices } from './MediaServices';

export { CameraPhoto } from './CameraPhoto';
export const FACING_MODES = MediaServices.FACING_MODES;
export const IMAGE_TYPES = MediaServices.IMAGE_TYPES;

// For debugging only
export { _getDebugPlatformInfo } from './MediaServices';



// WEBPACK FOOTER //
// ./src/lib/CameraPhoto/index.js